import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export interface OperationUsage {
  operation: string;
  /** What in our app caused these calls. Only TTLock attributes this today. */
  trigger: string;
  calls: number;
  errors: number;
  lastError: string | null;
}

export interface DailyUsage {
  day: string;
  calls: number;
  errors: number;
}

export interface ServiceUsage {
  service: string;
  totalCalls: number;
  totalErrors: number;
  callsLast24h: number;
  /** The plan's allowance, when one is configured. */
  quota: number | null;
  quotaPeriod: string | null;
  operations: OperationUsage[];
  daily: DailyUsage[];
}

export interface ApiUsage {
  services: ServiceUsage[];
}

export const getApiUsage = async (token: string, days = 30): Promise<ApiUsage> => {
  const res = await axios.get(`${API_BASE}/admin/api-usage`, {
    params: { days },
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};
